import { LegacyDevice } from 'console/device/device';
import { set_ui_settings } from './settings-actions';
import { open_z3k_settings } from 'z3k-settings/redux/actions';
import { open_climatic_settings } from '../climatic/settings-actions';
import { Capability } from '../device/device-capability';
import { selectDevice, selectSelectedDevice } from 'entities/device/lib';
import { _pickDevice } from 'console/redux/devices/selected-id';
import { eventsStateFiltered } from 'console/tabs/events/utils';
const emptyFilter = {};
export const applyNewEvent = (msg) => (dispatch, getState, { browser_notification_manager }) => {
    const device = selectDevice(getState(), msg.device_id);
    const device_name = device != null ? LegacyDevice.display_name(device) : undefined;
    const user_event_filter = getState().ui_settings.event_filter ?? emptyFilter;
    const show_network_events = getState().account.show_network_events || getState().account.is_staff;
    const event = {
        device_id: msg.device_id,
        device_name,
        type: msg.event_name,
        icon: msg.icon,
        time: msg.time,
        important: msg.important,
        x: msg.gps != null ? msg.gps.x : undefined,
        y: msg.gps != null ? msg.gps.y : undefined,
        title: msg.title,
        details: msg.details,
        // data: msg.data
        // duration: msg.duration
    };
    const show_event = eventsStateFiltered(user_event_filter, show_network_events, event);
    if (!show_event) {
        return;
    }
    if (event.important) {
        browser_notification_manager?.notify?.(event);
    }
    const device_id = msg.device_id;
    dispatch({ type: 'APPLY_NEW_EVENT', event, device_id });
};
export const changeTab = (tab_key) => set_ui_settings({ selected_tab_key: tab_key });
export const pickDevice = (device_id) => (dispatch, getState, { device_manager }) => {
    if (device_manager) {
        // need for update legacy device settings dialog
        device_manager.selectedDevice(device_manager.device(device_id));
    }
    //@ts-ignore
    dispatch(_pickDevice(device_id));
};
export const requestGetAllStates = () => async (dispatch, getState, { api }) => {
    const device_id = getState().devices.selected_id;
    if (device_id == null) {
        return;
    }
    await api.request_get_all_states(device_id);
};
export const logout = () => (dispatch, getState, { logout }) => logout?.();
export const openOTDiagnosticsDialog = (device_id) => (dispatch, getState, { open_ot_diagnostics_dialog }) => open_ot_diagnostics_dialog?.(device_id);
export const setEmailOk = (email) => ({
    type: 'SET_EMAIL__OK',
    email,
});
export const setEmail = (email) => async (dispatch, getState, { api }) => {
    dispatch({ type: 'SET_EMAIL__REQUEST' });
    try {
        await api.set_initial_email(email);
        dispatch({ type: 'SET_EMAIL__OK', email });
    }
    catch (error1) {
        const { json: { error, error_ui }, } = error1;
        switch (error) {
            case 'email_already_set':
                dispatch({ type: 'SET_EMAIL__OK', email });
                break;
            default:
                dispatch({
                    type: 'SET_EMAIL__FAIL',
                    error: error_ui != null ? error_ui : error,
                });
                break;
        }
    }
};
export const openImportantEventsDialog = () => ({ type: 'IMPORTANT_EVENTS_DIALOG__OPEN' });
export const closeImportantEventsDialog = () => ({ type: 'IMPORTANT_EVENTS_DIALOG__CLOSE' });
export const clearEventOnMap = () => ({ type: 'CLEAR_EVENT_ON_MAP' });
export const markAllEventsAsRead = () => async (dispatch, getState, { api }) => {
    dispatch({ type: 'MARK_ALL_EVENTS_AS_READ' });
    await api.mark_events_as_read();
};
export const importantEventsReloaded = (events) => ({ type: 'IMPORTANT_EVENTS_RELOADED', events });
export const requestImportantEvents = () => async (dispatch, getState, { api }) => {
    const { important_events } = await api.important_events_loc();
    dispatch(importantEventsReloaded(important_events));
};
export const showEventOnMap = (event) => (dispatch) => {
    if ((event != null ? event.loc() : undefined) != null) {
        if (event.device_id() != null) {
            dispatch(pickDevice(event.device_id()));
        }
        dispatch(changeTab('map'));
        dispatch({ type: 'SHOW_EVENT_ON_MAP', event });
    }
    else {
        dispatch({ type: 'CLEAR_EVENT_ON_MAP' });
    }
};
export const openDeviceSettingsDialog = (ctrl_pressed = false, device_id) => (dispatch, getState, { open_device_settings_dialog }) => {
    const device = device_id
        ? selectDevice(getState(), device_id)
        : selectSelectedDevice(getState());
    if (!device) {
        return;
    }
    if (LegacyDevice.has_capability(device?.capabilities, Capability.has_climatic_interface)) {
        if (ctrl_pressed) {
            dispatch(open_z3k_settings(device.id));
        }
        else {
            dispatch(open_climatic_settings(device.id));
        }
    }
    else {
        open_device_settings_dialog?.();
    }
};
